import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function Testimonials() {
  return <section className="bg-sand py-14 sm:py-20" data-id="element-241" data-mp="3mgsks6m6b79w">
      <div className="mx-auto w-full max-w-4xl px-4" data-id="element-242" data-mp="3mg0p6vskt9jm">
        <div className="text-center" data-id="element-243" data-mp="3r78y7qpzusw9">
          <div className="flex items-center justify-center gap-1.5" data-id="element-244" data-mp="3r8amiww0tbvx">
            {[0, 1, 2, 3, 4].map(index => <StarIcon key={index} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-245" data-mp="y3ecbkuodd" />)}
            <span className="ml-1.5 text-sm font-extrabold text-navy-900" data-id="element-246" data-mp="44nqexclsxwa">4.9/5</span>
          </div>
          <h2 className="mt-4 font-display text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-247" data-mp="9032pkuyqlql">
            What orthodontic professionals are saying
          </h2>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-248" data-mp="2avdgm2pso4st">
          {testimonials.map((item, index) => <li key={item.name} className={['flex h-full flex-col rounded-2xl bg-white p-5 ring-1 ring-navy-900/10 sm:p-6', index === 0 ? 'sm:col-span-2' : ''].join(' ')} data-id="element-249" data-mp="2fu6rdndp5hpa" data-mpi={index}>
              <div className="flex items-center gap-1" aria-label="Rated 5 out of 5" data-id="element-250" data-mp="1ivizac4jf9yu">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-251" data-mp="1erbbch5wly1o" />)}
              </div>
              <p className="mt-3 font-display text-[19px] font-bold leading-snug text-navy-900 sm:text-xl" data-id="element-252" data-mp="26ldg14rz9iod">
                “{item.quote}”
              </p>
              <p className="mt-3 text-[14.5px] leading-relaxed text-navy-800/80" data-id="element-253" data-mp="1xjmaq11cndv1">{item.body}</p>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-254" data-mp="r3jzfeo9zn0x">
                <img src={item.photo} alt={`${item.name}, orthodontist in ${item.country}`} className="h-12 w-12 rounded-full object-cover ring-2 ring-navy-900/10" width={96} height={96} loading="lazy" data-id="element-255" data-mp="r4v37ehq0us1" />
                <div data-id="element-256" data-mp="eky3z2wq2lac">
                  <p className="text-[14.5px] font-bold text-navy-900" data-id="element-257" data-mp="elhc5rwklvb6">{item.name}</p>
                  <p className="text-[13px] text-navy-800/65" data-id="element-258" data-mp="im9l0k1j5y6x">{item.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-259" data-mp="4tto80z82weg">
          <CTAButton label="Yes — I want to analyze cases with a system" data-id="element-260" data-mp="9md2z19nbxku" />
        </div>
      </div>
    </section>;
}